<template>
  <div class="nicerule-root">
    <div class="nicerule-content">&#9829;</div>
    <div class="nicerule-line"></div>
  </div>
</template>

<script>
  export default {
    name: 'NiceRule',
  }
</script>

<style lang="scss" scoped>
  .nicerule-root {
    width: 20em;
    display: block;
    position: relative;
    margin: 2em auto;

    .nicerule-line {
      display: inline-block;
      width: 100%;
      height: 1px;
      background-image: linear-gradient(
          to right,
          rgba(0, 0, 0, 0),
          var(--text-color-unpop),
          rgba(0, 0, 0, 0)
      );
    }

    .nicerule-content {
      display: inline-block;
      position: absolute;
      top: 0.25em;
      left: 50%;
      transform: translateX(-50%);
      padding: 0 1em;
      background: white;
      color: var(--text-color-unpop);
      height: 1em;
    }

  }

</style>
